import { render, staticRenderFns } from "./CompanyEditor.vue?vue&type=template&id=0065f5da&scoped=true"
import script from "./CompanyEditor.vue?vue&type=script&lang=js"
export * from "./CompanyEditor.vue?vue&type=script&lang=js"
import style0 from "./CompanyEditor.vue?vue&type=style&index=0&id=0065f5da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0065f5da",
  null
  
)

export default component.exports